import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./helpers/store";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastContainer } from "react-toastify";
// import axiosInterceptor from "./interceptor/request.interceptor";
const root = ReactDOM.createRoot(document.getElementById("root"));
const strictMode = process.env.NODE_ENV === "production";
const google_client_id = process.env.REACT_APP_GOOGLE_CLIENT_ID;


root.render(
  (strictMode && (
    <GoogleOAuthProvider clientId={google_client_id}>
    <ToastContainer />
    <React.StrictMode>
      <Provider store={store}>
      {/* <axiosInterceptor> */}
        <App />
      {/* </axiosInterceptor> */}
      </Provider>
    </React.StrictMode>
    </GoogleOAuthProvider>
  )) || (
    <GoogleOAuthProvider clientId={google_client_id}>
    <ToastContainer />
    <Provider store={store}>
      <App />
    </Provider>
    </GoogleOAuthProvider>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
